module.exports = __webpack_public_path__ + "static/media/Rectangle 195@2x.0d868281.png";